import { render } from "./TagComponent.vue?vue&type=template&id=db784bc6"
import script from "./TagComponent.vue?vue&type=script&lang=js"
export * from "./TagComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__